import React from "react";
import { Tooltip } from "@mui/material";
import { AccountBalance as AccountBalanceIcon } from "../icons";
import { T } from "./Translate";

// Cuenta oficial de gobierno/organismo público (se otorga desde AdminPanel.js,
// colección officialAccounts). Va al lado del nombre, igual que VerifiedBadge.
const OfficialBadge = ({ sx = {} }) => (
  <Tooltip title={<T>Cuenta oficial</T>}>
    <AccountBalanceIcon
      sx={{
        fontSize: "1rem",
        color: "#2e7d32",
        ml: 0.5,
        verticalAlign: "middle",
        ...sx,
      }}
    />
  </Tooltip>
);

export default OfficialBadge;
